import { IEquipmentAllotment } from 'app/shared/model/equipment-allotment.model';
import { IEquipmentIPCharges } from 'app/shared/model/equipment-ip-charges.model';
import { IHospitalPatientCategoryAttributes } from 'app/shared/model/hospital-patient-category-attributes.model';

export interface IEquipmentAllotmentCharge {
  id?: string;
  fromDate?: number;
  toDate?: number | null;
  active?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  quantity?: string | null;
  discount?: number | null;
  allotment?: IEquipmentAllotment | null;
  appliedCharge?: IEquipmentIPCharges | null;
  multiplierEntry?: IHospitalPatientCategoryAttributes | null;
}

export const defaultValue: Readonly<IEquipmentAllotmentCharge> = {
  active: false,
};
